/****************************************************
 * Module Name:  uploadToRapnetModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Box, Button } from "@mui/material";
import Select from "react-select";

import logo from "../../images/pansuriya.jpg";
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import RapnetLoginsProxy from "../../utility/proxy/manager/rapnetLoginsProxy";
import SaveIcon from '@mui/icons-material/Save';

export default function UploadToRapnetModal({
    show,
    loading,
    setShow,
    stoneIds,
    discount,
    stoneData,
    handleSave,
    ppcDiscount,
    handleValidation,
}) {
    const [showError, setShowError] = useState(false);
    const [rapnetData, setRapnetData] = useState({
        rapnetSelected: [],
        rapnetIdOptions: [],
    });

    useEffect(() => {
        fetchRapnetLoginsData();
    }, [])

    const fetchRapnetLoginsData = () => {
        RapnetLoginsProxy.getAllRapnetLoginsMini((res) => {
            if (res) setAllRapnetLoginsData(res);
        })
    }

    const setAllRapnetLoginsData = (res) => {
        if (res) {
            let optionsArray = [];
            res.map((data) => {
                let option = { value: data, label: data }
                optionsArray.push(option);

                return true;
            })
            setRapnetData({
                rapnetIdOptions: optionsArray,
                rapnetSelected: optionsArray.length > 0 ? [optionsArray[0]] : []
            })
        }
    }

    const saveHandler = () => {
        let tempRapnetUpload = [];
        // let tempDiscount = Object.keys(discount);
        rapnetData.rapnetSelected.map((rapnetId) => {
            stoneData.map((stone, index) => {
                if (stoneIds.includes(stone.stoneid)) {
                    let data = {
                        rapnetid: rapnetId.value,
                        stoneid: stone.stoneid,
                        createdby: Constants.loggedInUser.id,
                        createdat: stone.createdat,
                        discount: discount[stone.stoneid] ? discount[stone.stoneid] : "",
                        ppcdiscount: ppcDiscount ? ppcDiscount[stone.stoneid] : "",
                        status: stone.status === "OFFLINE" ? "DELETED" : "",
                    };
                    tempRapnetUpload.push(data);
                }
                return true;
            })
            return true;
        })


        if (handleSave) {
            if (handleValidation) {
                if (handleValidation(tempRapnetUpload)) {
                    handleSave(tempRapnetUpload);
                } else {
                    setShowError(true);
                }
            } else {
                handleSave(tempRapnetUpload);
            }
        }
    };

    const handleClose = () => {
        setShow(false);
    };

    const closeErrorDialog = () => {
        setShowError(false);
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={true}
            customer="lg"
            centered
            enforceFocus={false}
        >
            <CommonSnackbar
                show={showError}
                message={
                    <Box>
                        Stone Upload to Rapnet Failed
                        <br /> Please enter correct data
                    </Box>
                }
                variant={"error"}
                autoHide={false}
                handleClose={closeErrorDialog}
                title="Validation Failure"
            />
            <Modal.Header closeButton>
                <Modal.Title>
                    <img
                        src={logo}
                        height="40pt"
                        width="40pt"
                        alt={Constants.COMPANY_SITE}
                    />
                    &nbsp;&nbsp;Upload to Rapnet
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Box sx={{ display: "flex", flex: 1, gap: "20px" }}>
                    <Form.Label className="mt-2">Rapnet Id : </Form.Label>
                    <Select menuPlacement="auto"
                        isMulti
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        isSearchable={true}
                        name="Customer"
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        value={rapnetData.rapnetSelected}
                        options={rapnetData.rapnetIdOptions}
                        onChange={(selectedOption) => {
                            setRapnetData({
                                ...rapnetData,
                                rapnetSelected: selectedOption,
                            });
                        }}
                    />
                </Box>
            </Modal.Body>
            <Modal.Footer>
                <LoadingButton
                    loading={loading}
                    loadingPosition="start"
                    variant="contained"
                    color="success"
                    onClick={saveHandler}
                    type="Submit"
                    sx={{ mr: 3 }}
                    disabled={
                        rapnetData.rapnetSelected === undefined ||
                        rapnetData.rapnetSelected == null ||
                        rapnetData.rapnetSelected.length <= 0
                    }
                    startIcon={<SaveIcon size="large" />}
                >
                    Save
                </LoadingButton>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleClose}
                    sx={{ mr: 2 }}
                    disabled={loading}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}